(ns ui.wallet.top-up
  "The amount chooser of the wallet page (`ui.wallet.page`): preset chips
   and a custom input around the shared `:wallet/amount` store key, plus
   the claim-campaign command that runs before a checkout. The panels that
   use it live in `ui.wallet.on-demand`.

   Texts are `[:i18n ...]` references, resolved by `ui.wallet.page`."
  (:require [storrito.wallet :as wallet]))

(def presets
  ;; $5 is the promise of the onboarding subscribe screen ("Get started
  ;; from $5") and the wallet's minimum, so it has to be one click away.
  [5 10 20 50 100])

(def default-amount
  "The preselected amount. It used to be the server's monthly suggestion
   for the connected accounts ($21 for one account), which contradicted
   the \"from $5\" promise of the subscribe screen: in the week of
   08.–15.09.2026 79 signups opened this page and 15 went to the
   checkout. A small first purchase is the point of pay-as-you-go."
  10)

(defn amount
  "The monthly amount in USD. nil while the custom input holds no positive
   number (`:event/target.value-int` yields NaN for an empty field)."
  [w]
  (let [chosen (:wallet/amount w)]
    (cond
      (nil? chosen)
      default-amount

      (and (number? chosen)
           (pos? chosen))
      chosen

      :else
      nil)))

(def claim-campaign-command
  {:command/kind :command/claim-campaign
   :command/data {}})

(def choice-css
  ["px-4" "py-2" "text-sm" "font-semibold" "ring-1" "ring-inset"])

(def choice-selected-css
  ["bg-secondary-500" "text-white" "ring-secondary-500"])

(def choice-unselected-css
  ["bg-white" "text-gray-900" "ring-gray-300" "hover:bg-gray-50"])

(defn chip
  [w preset]
  [:button
   {:type "button"
    :class (concat ["rounded-md"]
                   choice-css
                   (if (= preset (amount w))
                     choice-selected-css
                     choice-unselected-css))
    :on {:click [[:store/assoc :wallet/amount preset]
                 [:client-log/log :wallet/amount-chosen {:wallet/amount preset}]]}}
   (str "$" preset)])

(defn custom-input
  "Shows the raw store value, so the field can be cleared while typing: with
   the fallback of `amount` the default would jump back in immediately."
  [w]
  (let [chosen (:wallet/amount w)]
    [:div.relative
     [:span.absolute.inset-y-0.left-3.flex.items-center.text-gray-500 "$"]
     [:input
      {:type "number"
       :min wallet/minimum-amount
       :step 1
       :aria-label [:i18n :top-up/custom-amount]
       :class ["w-28" "rounded-md" "border-0" "py-2" "pl-7" "pr-3" "text-sm"
               "text-gray-900" "ring-1" "ring-inset" "ring-gray-300"
               "focus:ring-2" "focus:ring-inset" "focus:ring-secondary-500"]
       :value (cond
                (nil? chosen) default-amount
                (js/isNaN chosen) ""
                :else chosen)
       :on {:input [[:store/assoc :wallet/amount :event/target.value-int]]}}]]))
